import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Table,
  Spin,
  Select,
  Divider,
  Col,
  Form,
  DatePicker,
  Modal,
} from "antd";

// PROJECT IMPORTS
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import { rightAction } from "../../../../redux/actions";
import DownloadTableButtons from "../../../../components/DownloadTableButtons";
import { apiConfig, labelConfig, staticConfig } from "../../operations.config";
import dayjs from "dayjs";
import Notiflix from "notiflix";
import styles from "../../../../assets/styles/styles";

const columns = [
  {
    title: labelConfig.id,
    dataIndex: "id",
  },
  {
    title: labelConfig.name,
    dataIndex: "name",
  },
  {
    title: labelConfig.clientNumber,
    dataIndex: "accountNo",
    sorter: (a, b) => a.accountNo.localeCompare(b.accountNo),
  },
  {
    title: labelConfig.staff,
    dataIndex: "staff",
  },

  {
    title: labelConfig.branch,
    dataIndex: "branch",
    sorter: (a, b) => a.branch.localeCompare(b.branch),
  },
];

const ManageClientApproval = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  //   const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [clientsData, setClientsData] = useState([]);
  const [loanList, setLoanList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [currentDate, setCurrentDate] = useState("");
  const childref = useRef();

  //DECLARED METHODS
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setClientsData(originalList);
      return;
    }

    const filterBySearch = originalList.filter(
      (item) =>
        item?.name?.toLowerCase().includes(searchKey) ||
        item?.branch?.toLowerCase().includes(searchKey)
    );

    setClientsData(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  //END METHODS DECLARED

  useEffect(() => {
    getClients();
    defaultDate();
  }, []);

  const defaultDate = () => {
    setCurrentDate(dayjs());
  };

  const getClients = () => {
    const params = {
      limit: 1000,
      status: "pending",
    };

    let body = {
      session,
      params,
    };
    setIsLoading(false);
    BOM.FetchReqAction(body, apiConfig.Clients, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res.pageItems;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element.id,
            name: element.displayName,
            accountNo: element.accountNo,
            staff: element.staffName,
            branch: element.officeName,
          });
        });

        setClientsData(tempArray);
        setOriginalList(tempArray);
      }
    });
  };

  const onSelectItemAction = (selectedKeys, selectedRows) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRowKeys(selectedKeys);
    setSelectedRow(selectedRows);

    if (selectedKeys.length === 1 || selectedKeys.length > 1) {
      BOM.HasPermission("ACTIVATE_CLIENT_CHECKER") &&
        [cnt.RIGHT_APPROVE_BTN].map((item) => {
          dispatch({ type: item });
        });
    } else {
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectItemAction,
    selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],
  };

  function handleApprove() {
    childref?.current?.showModal();
  }

  return (
    <MainLayout isEnableRightSidebar={true} onApprove={handleApprove}>
      <TopContent
        pageTitle={labelConfig.manageClientApproval}
        pageItems={staticConfig.manageClientApprovalBreadcrumbItems}
      />

      <Card
        title={`${labelConfig.clientApproval} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/*RENDER TABLE LIST HERE*/}

        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name/Branch..."
                style={{
                  width: 400,
                }}
              />
            </div>
            <DownloadTableButtons
              downloadData={clientsData}
              columns={columns}
              fileName={"Client Approval List"}
            />
          </Row>
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={clientsData}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />

          <Row>
            <ActivateModal
              userData={userData}
              ref={childref}
              dispatch={dispatch}
              selectedRow={selectedRow}
              currentDate={currentDate}
              setSelectedRowKeys={setSelectedRowKeys}
              setSelectedRow={setSelectedRow}
            />
          </Row>
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageClientApproval);

const ActivateModal = forwardRef((props, ref) => {
  const {
    userData,
    setSelectedRowKeys,
    setSelectedRow,
    dispatch,
    selectedRow,
    currentDate,
  } = props;
  const { session } = userData;
  const [useForm] = Form.useForm();

  const [editFixedDepositDetail, setEditFixedDepositDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dateFormat = "YYYY/MM/DD";

  // MODAL VARIABLES
  const [isModalOpen, setIsModalOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setIsModalOpen(true);
    },
  }));

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = (formValues) => {
    let tempBatchArray = selectedRow.map((element, index) => ({
      requestId: index + 1,
      relativeUrl: `clients/${element.id}?command=activate`,
      method: "POST",
      body: JSON.stringify({
        activationDate: BOM.DateTime(currentDate, "only-date"),
        dateFormat: "dd MMMM yyyy",
        locale: "en",
      }),
    }));

    tempBatchArray.session = session;
    tempBatchArray.method = "POST";

    const url = apiConfig.Batches;

    BOM.FetchReqAction(tempBatchArray, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        //STOP LOAD
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Approved successfully");
        dispatch({
          type: cnt.CLEAR_RIGHT_BTN,
        });

        // Clear selection after successful approval
        setSelectedRowKeys([]);
        setSelectedRow([]);
        setIsModalOpen(false);
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <Modal
        title="Enter Clients Activation Date"
        open={isModalOpen}
        okText="Submit"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm} onFinish={onSubmit}>
            {dom}
          </Form>
        )}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider orientation="left"></Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.activationDate}
                name="activationDate"
              >
                <DatePicker
                  format={dateFormat}
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
});
